import { cn } from '@/lib/utils';
import type { AnyFieldApi, AnyFieldMeta } from '@tanstack/react-form';

export function FieldError({
  field,
  className,
}: {
  field: AnyFieldApi;
  className?: string;
}) {
  return (
    <div className={cn('mt-1 text-red-500 text-sm font-nunito500', className)}>
      {field.state.meta.isTouched && field.state.meta.errors.length ? (
        <span>{field.state.meta.errors[0].message}</span>
      ) : null}
    </div>
  );
}

export function FieldErrorV2({
  meta,
  className,
}: {
  meta: AnyFieldMeta;
  className?: string;
}) {
  return (
    <div className={cn('mt-1 text-red-500 text-sm font-nunito500', className)}>
      {meta.isTouched && meta.errors.length ? (
        <span>{meta.errors[0].message}</span>
      ) : null}
    </div>
  );
}
